require('expose-loader?HomeComponent!../../src/app/home');
